import FeedbackService from "@/services/feedback.service";
import { ActionContext, Module } from "vuex";
import {
  FeedbackFormType,
  TopicItem,
  TicketType,
} from "@/struct/FeedbackStruct";
import type { RootState } from "@/store";

const feedbackService = new FeedbackService();

export interface FeedbackState {
  topics: string[];
  feedbackShownVisits: number[];
  feedbackSubmitted: boolean;
}

const feedbackModule: Module<FeedbackState, RootState> = {
  namespaced: true,
  state: () => ({
    topics: [],
    feedbackShownVisits: [],
    feedbackSubmitted: false,
  }),
  getters: {},
  mutations: {
    SET_TOPICS(state, payload: string[]) {
      state.topics = payload;
    },

    SET_FEEDBACK_SHOWN_VISITS(state, value: number[]) {
      state.feedbackShownVisits = value;
    },
    SET_FEEDBACK_SUBMITTED(state, value: boolean) {
      state.feedbackSubmitted = value;
    },
  },
  actions: {
    fetchTopics({ commit }) {
      return feedbackService
        .getTopics()
        .then((res) => {
          const topics = (res.data.response as TopicItem[]).map(
            (item) => item.display_name
          );
          commit("SET_TOPICS", topics); // заменяет, а не дописывает — баг с дублями исчезает сам собой
        })
        .catch((err) => {
          console.log(err);
        });
    },

    sendFeedback(
      _: ActionContext<FeedbackState, RootState>,
      data: FeedbackFormType
    ) {
      return feedbackService.sendFeedback(data);
    },

    sendTicket(_: ActionContext<FeedbackState, RootState>, data: TicketType) {
      return feedbackService.sendTicket(data);
    },

    updateFeedbackShownVisits({ commit }, value: number[]) {
      commit("SET_FEEDBACK_SHOWN_VISITS", value);
    },
    updateFeedbackSubmitted({ commit }, value: boolean) {
      commit("SET_FEEDBACK_SUBMITTED", value);
    },
    addFeedbackShownVisit({ state, dispatch }, visit: number) {
      const current = Array.isArray(state.feedbackShownVisits)
        ? state.feedbackShownVisits
        : [];
      if (!current.includes(visit)) {
        dispatch("updateFeedbackShownVisits", [...current, visit]);
      }
    },
  },
};

export default feedbackModule;
